import DOMPurify from "dompurify";
import styles from "./bigVideoLayout.module.css";
import parallax from "../parallax";
import { useRef, useEffect } from "react";

const BigVideoLayout = ({
  title,
  src,
  textAlign = "left",
  poster,
  setImgLoadComplate = () => {},
}) => {
  const h1 = useRef(null);
  const ctn = useRef(null);
  useEffect(() => {
    parallax(
      {
        trigger: ctn.current,
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
      h1.current
    );
  }, []);
  return (
    <div
      className={styles.ctn}
      ref={ctn}
      style={{
        justifyItems: textAlign === "left" ? "flex-start" : "flex-end",
      }}
    >
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(title),
        }}
        ref={h1}
      ></h1>
      <video
        autoPlay
        loop
        playsInline
        muted
        preload="true"
        src={src}
        poster={poster}
        onLoadedData={setImgLoadComplate()}
      ></video>
    </div>
  );
};

export default BigVideoLayout;
